var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"confHistCanvas",staticClass:"w-100 h-100",attrs:{"height":"96","width":"256"}})])}
var staticRenderFns = []

export { render, staticRenderFns }